'use client';
import React, { memo } from 'react';

import { useLang } from '@/hooks';

const Category = memo(() => {
	const { t } = useLang();
	const categories = [
		{ label: 'Technical' },
		{ label: 'Design' },
		{ label: 'Travel' },
		{ label: 'Food' },
	];

	return (
		<div className="relative px-6 py-3 bg-white rounded-lg shadow-default mt-[76px]">
			<div className={'bg-blue-50 border border-blue-1 py-2 px-4 rounded-default absolute top-0 left-[50%] translate-x-[-50%] translate-y-[-50%]'}>
				<p className={'text-[13px] uppercase font-bold text-blue-7 leading-tight'}>{t('tag.categories')}</p>
			</div>
			<div className={'cursor-pointer flex-wrap row gap-3 mt-10'}>
				{categories.map((item: any, index: number) => (
					<div
						key={index.toString()}
						className={'bg-green-1 px-2 py-0.5 rounded-[6px]'}
					>
						<span className={'text-sm text-white font-medium'}>
							{item.label}
						</span>
					</div>
				))}
			</div>
		</div>
	);
});

export default Category;
